require("./vueditor/index.js");
require("./vue-trumbowyg/index.js");
require("./vue-input-tag/index.js");
